// test959
(959 && 0);
